export default "/assets/7e593a79ea612485.svg"